import React, { useContext } from "react";
import { DataContext } from "../../contexts/DataContext";
import CompetitionEdit from "../Competition/CompetitionEdit";
import SavePanel from "../UI/Form/SavePanel";
import Modal from "../UI/Modal/Modal";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";
import PanelTitle from "../UI/Panel/PanelTitle";
import InsighteEdit from "../Insights/InsightEdit";

export default function InsightEditor({
  fact,
  facts,
  fixture,
  onSave,
  onCancel,
  selectFact,
}) {
  const { updateGameInsights } = useContext(DataContext);
  return (
    <Modal
      style={{ width: "50%" }}
      show={fact}
      onCancel={() => {
        selectFact();
        onCancel();
      }}
    >
      {fact && (
        <Panel style={{ marginTop: "-25%" }}>
          <PanelTitle title={"Inisght Edit"}>
            <div>{fact.id}</div>
          </PanelTitle>
          <PanelContent>
            <InsighteEdit
              fact={fact}
              onChange={(s) => {
                selectFact(s);
              }}
            />
          </PanelContent>

          <SavePanel
            showDelete={false}
            onSave={() => {
              let new_insights = JSON.parse(JSON.stringify(facts));
              let index = facts?.findIndex((f) => f.id === fact.id);
              new_insights[index] = fact;

              updateGameInsights({
                id: fixture?._id,
                insights: new_insights,
              }).then(() => {
                selectFact();
                onSave();
              });
            }}
            onCancel={() => {
              selectFact();
              onCancel();
            }}
          ></SavePanel>
        </Panel>
      )}
    </Modal>
  );
}
